<table class="tabTable" id="kendo_card_table" style="text-align: left;" #tabTable>
  <thead>
    <tr>
      @for (column of gridControl.gridOptions.columns; track column.field) {
      <th [title]="column.title" [width]="column.size">
        {{ column.title }}
      </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of gridControl.gridOptions.data; track row) {
    <tr>
      @for (column of gridControl.gridOptions.columns; track column.field) {
      <td style="padding: 8px 14px;" [style.width.%]="column.size">
        <span>{{ getConvertedItemValue(row[column.field], column.format) }}</span>
      </td>
      }
      }
  </tbody>
</table>
